$(document).ready(function(){
  initPage();
  pageLoading();
});

function initPage(){
  swipers();
  popups();
  forms();
  menu();
  nouisliders();
  autoRefresh();
  filters();
  gallery();
  product();
  quantity();
  invoices();
  search();
  addressForm();
  reccomadation();
  tracker();
  coupons();
  toTop();
  details();
  giftCard();
  newsletter();
}

function newsletter(){
  $('#newsletter-birthday').on('blur', function(){
    var full = $(this).val();
    var hidden = $('#birthday-hidden');
    var parts = full.split('/');
    if(parts.length > 1){
      $(hidden).val(full);
    } else {
      $(hidden).val(" ");
    }
  });
}

function tracker(){
  addEvent('click', '[data-click]', 'trackclick', function(el){
    $(window).trigger('theme-click', {
      type: $(el).attr('data-click'),
      label: $(el).attr('data-click-label'),
      category: $(el).attr('data-click-category')
    });
  });

  addEvent('click', '[data-product]', 'productclick', function(el){
    var json = JSON.parse($(el).find('[data-product-json]').text());
    $(window).trigger('theme-product-click', json);
  });
}

function swipers(){
  $('[data-swiper]').each(function(){
    var opt = {
      autoHeight: false,
      spaceBetween: parseInt($(this).attr('data-swiper-margin')) > 0 ? parseInt($(this).attr('data-swiper-margin')) : 0
    };
    if($(this).attr('data-swiper-pagination') != undefined){
      opt.pagination = {
        el: ".swiper-pagination",
        draggable: true,
        dynamicBullets: true,
        clickable: true
      };
    }
    if($(this).attr('data-swiper-navigation') != undefined){
      opt.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if($(this).attr('data-swiper-scrollbar') != undefined){
      opt.scrollbar = {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: true
      };
    }
    if(parseInt($(this).attr('data-swiper-autoplay')) > 0){
      opt.autoplay = {
        delay: $(this).attr('data-swiper-autoplay'),
        disableOnInteraction: false,
      };
    }
    if($(this).attr('data-swiper-autowidth') != undefined){
      opt.slidesPerView = "auto";
    } else if($(this).attr('data-swiper-breakpoints') != undefined){
      var points = $(this).attr('data-swiper-breakpoints').split(',');
      opt.breakpoints = {};
      $(points).each(function(){
        var els = this.split(':');
        if(els[0].localeCompare('default') == 0){
          opt.slidesPerView = els[1];
        } else {
          opt.breakpoints[els[0]] = {
            slidesPerView: els[1]
          }
        }
      });
    }
    try{
      var swiper = new Swiper(this, opt);
    } catch(e){
      console.log(e);
      console.log('error with swiper');
    }
  });
}

function forms(){
  if($.validator != undefined){
    $.extend($.validator.messages, form_errors);
    $('[data-validate]').each(function(){
      $(this).validate({
        highlight: function(element) {
            $(element).parents('.form-group').addClass("was-validated");
        },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass("was-validated");
        },
        errorPlacement: function(error, element) {
          var placement = $(element).parents('.form-group').find('.invalid-feedback');
          $(placement).append(error);
        }
      });
    });
  
    addEvent('click', '[data-validate-submit]', 'submitform', function(el){
      var form = $(el).parents('form');
      if($(form).length && $(form).valid()){
        pageLoading();
        $(form).trigger('theme-form-success');
        $(form).trigger('submit');
      } else { 
        $(window).trigger('theme-form-error', {
          data: new FormData($(form).get(0))
        });
      }
    });
  }
  
  $('[data-mask]').each(function(){
    var format = $(this).attr('data-mask');
    var placeholder = $(this).attr('data-mask-placeholder');
    Inputmask({
      "mask" : format,
      "placeholder": placeholder,
    }).mask(this);
  });

  $('[data-form-error]').each(function(){
    var form = $(this).parents('form');
    $(window).trigger('theme-form-error', {
      data: new FormData($(form).get(0))
    });
  });

  $('[data-form-newsletter]').each(function(){
    var form = $(this).parents('form');
    $(window).trigger('theme-form-newsletter');
  });
}

function pageLoading(){
  $('#loader').toggleClass('d-none');
  console.log($('#loader').hasClass('d-none'));
}

function loadPage(url, selector, callback, addstate=true){
  if(url != undefined && selector != undefined){
    $.get(url, function(data){
      var newdom = new DOMParser().parseFromString(data, 'text/html');
      var element = $(newdom).find(selector);
      if($(element).length){
        var content = $(element).html();
        $(selector).html(content);
        if(addstate)
          window.history.pushState({"html": data,"pageTitle":$(newdom).find('title').text()},"", url);
        if(callback != undefined && callback != null){
          callback();
        } else {
          pageLoading();
        }
        if(selector != 'body'){
          initPage();
          $(window).trigger('theme-reload');
        }
      } else {
        console.log('error loadpage');
        console.log(element);
      }
    });
  }
}

function autoRefresh(){
  addEvent('click', '[data-refresh]', 'refreshbutton', function(el, e){
    e.preventDefault();
    pageLoading();
    var url = $(el).attr('href');
    var selector = $(el).attr('data-refresh');
    loadPage(url, selector);
  });
}

function popups(){
  $('[data-popup-now]').each(function(){
    var id = $(this).attr('id');
    var modal = new bootstrap.Modal(document.getElementById(id), {});
    modal.show();
  });
  $('[data-popup-delay]').each(function(){
    var delay = parseInt($(this).attr('data-popup-delay'))*1000;
    var id = $(this).attr('id');
    var modal = new bootstrap.Modal(document.getElementById(id), {});
    setTimeout(function(){
      modal.show();
    }, delay);
  });
  $('[data-popup-scroll]').each(function(){
    var percentage = parseInt($(this).attr('data-popup-scroll'));
    var id = $(this).attr('id');
    var modal = new bootstrap.Modal(document.getElementById(id), {});
    $(window).on('scroll', function(){
      if(getScrollPercent() >= percentage){
        modal.show();
        $(window).off('scroll');
      }
    })
  });
}

function menu(){
  addEvent('click', '[data-menu-toggle]', 'menumobile', function(el){
    var p = $(el).parents('[data-menu-parent]');
    var menu = $(p).find('[data-menu]');
    $(menu).toggleClass('active');
  });
}

function nouisliders(){
  $('[data-uislider]').each(function(){
    var el = this;
    var min = Number($(this).attr('data-uislider-from'));
    var max = Number($(this).attr('data-uislider-to'));
    var start = Number($(this).attr('data-uislider-min'));
    var end = Number($(this).attr('data-uislider-max'));
    var symbol = $(this).attr('data-uislider-symbol');
    var minparam = $(this).attr('data-uislider-minparam');
    var maxparam = $(this).attr('data-uislider-maxparam');

    var parent = $(this).parents('[data-uislider-parent]');
    var minvalue = $(parent).find('[data-uislider-minvalue]');
    var maxvalue = $(parent).find('[data-uislider-maxvalue]');

    var url = new URL(location.href);
    
    if(this.noUiSlider == undefined){
      var slider = noUiSlider.create(this, {
        start: [start, end],
        connect: true,
        'step': 500,
        range: {
          'min': min,
          'max': max
        }
      }, true);
      slider.on('update', function(values){
        $(minvalue).text(symbol+(values[0]/100).toFixed(2));
        $(maxvalue).text(symbol+(values[1]/100).toFixed(2));
      });
      if(minparam != undefined && maxparam != undefined){
        slider.on('change', function(values){
          if(values[0] != start){
            url.searchParams.set(minparam, values[0]/100);
          }
          if(values[1] != end){
            url.searchParams.set(maxparam, values[1]/100);
          }
          if(values[0] != start || values[1] != end){
            reloadFilter({
              url: url,
              mainSelector: $(el).attr('data-filter-refresh'),
              filterSelector: $(el).attr('data-filter-list'),
              enable: $(el).attr('data-filter-enable') == 'true',
              filter: $(el).attr('data-filter-name'),
              value: values[0] != start ? values[0] : values[1]
            });
          }
        });
      }
    }
  });
}

function filters(){
  $('[data-filter]').each(function(){
    addEvent('click', this, 'filter', function(el, e){
      e.preventDefault();
      reloadFilter({
        url: $(el).attr('href'),
        mainSelector: $(el).attr('data-filter-refresh'),
        filterSelector: $(el).attr('data-filter-list'),
        enable: $(el).attr('data-filter-enable') == 'true',
        filter: $(el).attr('data-filter'),
        value: $(el).attr('data-filter-value')
      });
    });
  });
}

function reloadFilter(obj){
  pageLoading();
  loadPage(obj.url, obj.mainSelector, function(){
    loadPage(location.href, obj.filterSelector, function(){
      if(obj.enable){
        $(window).trigger('theme-filter-enabled', {
          filter: obj.filter,
          value: obj.value
        });
      } else {
        $(window).trigger('theme-filter-disabled', {
          filter: obj.filter,
          value: obj.value
        });
      }
      filters();
      pageLoading();
    });
  });
}

function gallery(){
  $('[data-gallery]').each(function(){
    var thumbs = $(this).find('[data-gallery-thumbs]');
    var main = $(this).find('[data-gallery-main]');

    var swiper = new Swiper($(thumbs).get(0), {
      spaceBetween: 5,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        992: {
          direction: 'vertical'
        }
      }
    });
    
    var swiper2 = new Swiper($(main).get(0), {
      pagination : {
        el: ".swiper-pagination",
        draggable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      }
    });
  });
}

function product(){
  addEvent('change', '[data-product-variants]', 'variants', function(el){
    var url = $(el).find('option:selected').attr('data-product-url');
    var form = $(el).parents('form');
    loadPage(url, '#'+$(form).attr('id'), function(){
    });
  });

  addEvent('click', '[data-product-add]', 'addtocard', function(el){
    var form = $(el).parents('form').get(0);
    addToCart(form, function(){
      pageLoading();
      var drawer = bootstrap.Offcanvas.getInstance($('#theme-cart').get(0));
      if(drawer == null || drawer == undefined){
        drawer = new bootstrap.Offcanvas($('#theme-cart').get(0));
      }
      drawer.show();
    });
  });
  
  $('[data-quickview]').each(function(){
    $(this).validate({
      highlight: function(element) {
          $(element).parents('.form-group').addClass("was-validated");
      },
      unhighlight: function(element) {
          $(element).parents('.form-group').removeClass("was-validated");
      },
      errorPlacement: function(error, element) {
        var placement = $(element).parents('.form-group').find('.invalid-feedback');
        $(placement).append(error);
      }
    });
  });

  addEvent('click', '[data-quickview-submit]', 'addfromquickview', function(el){
    var form = $(el).parents('form').get(0);
    if($(form).length && $(form).valid()){
      addToCart(form, function(){
        pageLoading();
        var drawer = bootstrap.Offcanvas.getInstance($('#theme-cart').get(0));
        if(drawer == null || drawer == undefined){
          drawer = new bootstrap.Offcanvas($('#theme-cart').get(0));
        }
        drawer.show();
      });
    }
  });
}

function addToCart(form, callback){
  pageLoading();
  var params = new FormData(form);
  $.ajax({
    type: 'POST',
    url: $(form).attr('action'),
    data: params,
    dataType: 'json',
    cache: false,
    contentType: false,
    processData: false,
    success: function (data) {
      loadPage(location.href, '#body-wrapper', function(){
        $(window).trigger('theme-cart-add', data);
        callback();
      }, false);
    },
    error: function (err) {
      console.log(err);
      Swal.fire({
        "icon": "error",
        "title": err.responseJSON.errors
      });
      pageLoading();
    }
  });
}

function quantity(){
  $('[data-quantity-selector]').each(function(){
    var parent = this;
    var input = $(parent).find('input');
    var minus = $(parent).find('[data-quantity-minus]');
    var plus = $(parent).find('[data-quantity-plus]');
    var form = $(parent).parents('form');

    var min = parseInt($(parent).attr('data-quantity-min')) > 0 ? parseInt($(parent).attr('data-quantity-min')) : 0;
    var max = parseInt($(parent).attr('data-quantity-max')) > 0 ? parseInt($(parent).attr('data-quantity-max')) : 100;
    var val = parseInt($(input).val());
    var updateQuantity = $(parent).attr('data-quantity-count') != undefined;
    var selector = $(parent).attr('data-quantity-selector');

    addEvent('click', minus, 'qtyminus', function(el, e){
      e.preventDefault();
      if(val-1 >= min){
        $(input).val(val-1);
        val = val-1;
        updateForm(form, selector, updateQuantity);
      }
    });

    addEvent('click', plus, 'qtyplus', function(el, e){
      e.preventDefault();
      if(val+1 <= max){
        $(input).val(val+1);
        val = val+1;
        updateForm(form, selector, updateQuantity);
      }
    });

    addEvent('input', input, 'qtyinput', function(el){
      var n = parseInt($(el).val());
      if(n != val && n >= min && n <= max){
        val = n;
        updateForm(form, selector, updateQuantity);
      } else {
        $(input).val(val);
      }
    });
  });

  $('[data-cart-remove]').each(function(){
    addEvent('click', this, 'removecart', function(el, e){
      e.preventDefault();
      pageLoading();
      var url = $(el).attr('href');
      var selector = $(el).attr('data-cart-remove');
      var q = $(el).attr('data-cart-remove-quantity');
      var json = JSON.parse($(el).find('[data-item-json]').text());
      $.get(url, function(){
        loadPage(location.href, '#body-wrapper', function(){
          console.log('rimosso dal carrello');
          $(window).trigger('theme-cart-remove', json);
          pageLoading();
          if($('#theme-cart').length){
            var drawer = bootstrap.Offcanvas.getInstance($('#theme-cart').get(0));
            if(drawer == null || drawer == undefined){
              drawer = new bootstrap.Offcanvas($('#theme-cart').get(0));
            }
            drawer.show();
          }
        }, false);
      });
    });
  });
  
  function updateForm(form, selector, updateQuantity){
    if($(form).length){
      pageLoading();
      var params = new FormData($(form).get(0));
      $.ajax({
        type: 'POST',
        url: $(form).attr('action'),
        data: params,
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          loadPage(location.href, selector, function(){
            if(updateQuantity){
              $(window).trigger('theme-quantity-changed', data);
              counter(data.item_count);
            }
            pageLoading();
          }, false);
        },
        error: function (err) {
          console.log(err);
          Swal.fire({
            "icon": "error",
            "title": err.responseJSON.errors
          });
          pageLoading();
        }
      });
    }
  }

  function counter(q){
    var c = $('[data-cart-counter]');
    if(q > 0){
      $(c).text(q);
      $(c).removeClass('d-none');
    } else {
      $(c).addClass('d-none');
    }
  }
}

function invoices(){
  addEvent('click', '[data-invoice-submit]', 'invoicesubmit', function(el){
    pageLoading();
    var form = $(el).parents('form');
    if($(form).valid()){
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: new FormData($(form).get(0)),
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          pageLoading();
          Swal.fire({
            "icon": "success",
            "title": $(el).attr('data-invoice-submit')
          }).then((result) => {
            location.reload();
          });
        },
        error: function (err) {
          console.log(err);
          Swal.fire({
            "icon": "error",
            "title": err.responseJSON.errors
          });
        }
      });
    }
  });

  addEvent('click', '[data-invoice-remove]', 'invoiceremove', function(){
    pageLoading();
    var data = new FormData();
    data.append('attributes[invoice]', 0);
    data.append('attributes[invoice_company]', null);
    data.append('attributes[invoice_vat]', null);
    data.append('attributes[invoice_address]', null);
    data.append('attributes[invocie_pec]', null);
    data.append('attributes[invoice_type]', null);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        location.reload();
      },
      error: function (err) {
        console.log(err);
        Swal.fire({
          "icon": "error",
          "title": err.responseJSON.errors
        });
      }
    });
  });
}

function search(){
  $('[data-search-predictive]').each(function(){
    var form = this;
    var input = $(form).find('input');
    var container = $(form).attr('data-search-predictive');
    var content = $(container).html();

    addEvent('keyup', input, 'search', function(el){
      var terms = $(el).val();
      if(terms.length >= 3){
        var params = new URLSearchParams(new FormData(form)).toString();
        $.ajax({
          type: 'GET',
          url: '/search/suggest.json?'+params,
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            $(window).trigger('theme-search', {
              terms: terms,
              data: data
            });
            showResults(data.resources.results, container, content);
          },
          error: function (err) {
            $(container).html(content);
            console.log(err);
            Swal.fire({
              "icon": "error",
              "title": err.responseJSON.message,
              "text": err.responseJSON.description
            });
          }
        });
      } else {
        $(container).html(content);
      }
    });
  });

  function showResults(r, container, content){
    if(r.products.length > 0){
      $(container).html('');
      $(r.products).each(function(){
        var t = searchResult;
        t = t.replaceAll('{url}', this.url);
        t = t.replaceAll('{img}', this.image);
        t = t.replaceAll('{title}', this.title);
        t = t.replaceAll('{price}', this.price);
        $(container).append(t);
      });
    } else {
      $(container).html(content);
    }
  }
}

function addressForm(){
  $('.address-form').each(function(){
    address(this);
  });

  function address(form){
    var province = $(form).find('[data-province-select]');
    var country = $(form).find('[data-country-select]');

    setProvince();
    addEvent('change', country, 'country', setProvince);

    function setProvince(){
      try {
        var provinces = JSON.parse($(country).find('option:selected').attr('data-provinces'));
        if(provinces.length){
          var p = ['<option value=""></option>'];
          $(provinces).each(function(){
            p.push('<option value="'+this[0]+'">'+this[0]+'</option>');
          });
          $(province).html(p.join(''));
        } else {
          $(province).html("");
        }
      } catch{
        $(province).html("");
      }
    }
  }

}

function reccomadation(){
  $('[data-reccomandation-url]').each(function(){
    var el = this;
    var url = $(el).attr('data-reccomandation-url');
    fetch(url)
    .then(response => response.text())
    .then(text => {
      var html = $(text).find('[data-reccomandation-url]').html();
      $(el).html(html);
      swipers();
    })
    .catch(e => {
      console.error(e);
    });
  });
}

function coupons(){
  addEvent('click', '[data-coupon]', 'couponadd', function(el){
    var code = $(el).attr('data-coupon');
    var target = $(el).attr('data-coupon-target');
    var parent = $(el).parent();
    if($(target).length){
      $(target).val(code);
      $(el).remove();
      if($(parent).find('[data-coupon]').length <= 0){
        $(parent).remove();
      }
    }
  });
}

function addEvent(event, el, name, callback){
  var ev = $(el).attr('data-events');
  var parts = [];
  if(ev != undefined){
    parts = ev.split(',');
    if(parts.includes(name)){
      var notadd = true;
    }
  }
  if(notadd != true){
    var fnName = function(e, d){
      callback(this, e, d);
    }
    $(el).off(event, fnName).on(event, fnName);
    parts.push(name);
    $(el).attr('data-events', parts.join(','));
  }
}

function toTop(){
  var max = window.innerHeight / 2;
  addEvent('click', '#up', 'upbutton', function(){
    $("#body-wrapper").animate({ scrollTop: 0 }, "slow");
  });
  
  $('#body-wrapper').on('scroll', function(e){
    var y = $(this).scrollTop();
    if(y < max){
      $(up).addClass('invisible');
    } else {
      $(up).removeClass('invisible');
    }
  });

}

function details(){
  addEvent('click', '[data-details-inch]', 'inches', function(el){
    $(el).removeClass('text-secondary');
    $('[data-details-cm]').addClass('text-secondary');
    $('[data-details]').each(function(){
      var cm = parseInt($(this).attr('data-details'));
      var inch = (cm/2.54).toFixed(1);
      $(this).text(inch);
    });
  });
  addEvent('click', '[data-details-cm]', 'centimeters', function(el){
    $(el).removeClass('text-secondary');
    $('[data-details-inch]').addClass('text-secondary');
    $('[data-details]').each(function(){
      var cm = parseInt($(this).attr('data-details'));
      $(this).text(cm);
    });
  });
}

function initMap(){
  var filtered = [];
  if($('#map').length){
    var lat = Number($('#map').attr('data-latitude'));
    var long = Number($('#map').attr('data-longitude'));
    var zoom = parseInt($('#map').attr('data-zoom'));
    var map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: lat, lng: long },
      mapTypeId: 'roadmap',
      zoom: zoom,
    });
    
    for(var i=0;i<stores.length;i++){
      var latLng = new google.maps.LatLng(stores[i].latitude, stores[i].longitude);
      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        type: stores[i].type,
        title: stores[i].name,
        //icon: marker_icon,
        optimized: true,
        url: stores[i].link
      });
      google.maps.event.addListener(marker, 'click', function() {
        selectStore(this);
      });
      stores[i].marker = marker;
    }
    
    $('[data-store]').on('click', function(){
      
    });
    $('[data-locator-filter]').on('change', function(){
      filterStores($(this).val());
    });
    $('[data-locator-position]').on('click', function(){
      getPosition();
    });
    $('[data-store]').on('click', function(){
      setPosition(this);
    });

    searchBox = new google.maps.places.SearchBox($('#locator-address').get(0));
    map.addListener("bounds_changed", () => {
      searchBox.setBounds(map.getBounds());
      updateStores();
    });

    searchBox.addListener("places_changed", () => {
      searchAddress();
    });
  }

  function filterStores(type){
    $(stores).each(function(){
      var show = type == 'all' || type == this.type;
      if(show){
        this.marker.setMap(map);
        $('[data-store="'+this.id+'"]').removeClass('d-none');
      } else {
        this.marker.setMap(null);
        $('[data-store="'+this.id+'"]').addClass('d-none');
      }
    });
  }

  function updateStores(){
    $('[data-store]').addClass('d-none');
    var bounds = map.getBounds();
    var found = false;
    $(stores).each(function(){
      if(bounds.contains(this.marker.getPosition())){
        $('[data-store="'+this.id+'"]').removeClass('d-none');
        found = true;
      }
    });
    if(found){
      $('#no-stores').addClass('original-selector');
    } else {
      $('#no-stores').removeClass('original-selector');
    }
  }

  function getPosition(){
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    }
  }

  function showPosition(position) {
    map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
  }

  function searchAddress(){
    const places = searchBox.getPlaces();
    if (places.length == 0) {
      return;
    }
    places.forEach((place) => {
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      map.setCenter(place.geometry.location);
      //map.setZoom(15);
    });
  }

  function selectStore(m){
    var item = $('[data-store="'+m.id+'"]');
    $('[data-store]').removeClass('bg-light');
    $(item).addClass('bg-light');
  }

  function setPosition(el){
    var latitude = Number($(el).attr('data-store-lat'));
    var longitude = Number($(el).attr('data-store-lng'));
    var latLng = new google.maps.LatLng(latitude, longitude);
    map.setCenter(latLng);
    //map.setZoom(15);
    $('[data-store]').removeClass('bg-light');
    $(el).addClass('bg-light');
  }
}

function initStore(){
  var lat = Number($('#map').attr('data-latitude'));
  var long = Number($('#map').attr('data-longitude'));
  var zoom = parseInt($('#map').attr('data-zoom'));
  var map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: lat, lng: long },
    mapTypeId: 'roadmap',
    zoom: zoom,
  });

  var latLng = new google.maps.LatLng(lat, long);
  var marker = new google.maps.Marker({
    position: latLng,
    map: map,
    type: store.type,
    title: store.name,
    //icon: marker_icon,
    optimized: true,
    url: store.link
  });
}

function giftCard(){
  if($('#qr-code').length){
    var code = $('#qr-code').attr('data-identifier');
    new QRCode( document.querySelector('#qr-code'), {
      text: code,
      width: 150,
      height: 150,
      imageAltText: 'qr'
    });
  }

  addEvent('click', '[data-copy]', 'copy', function(el){
    navigator.clipboard.writeText($(el).attr('data-copy'));
    var feed = $(el).attr('data-copy-element');
    var copied = $(el).attr('data-copy-text');
    var text = $(feed).text();
    
    $(feed).text(copied);
    setTimeout(function(){
      $(feed).text(text);
    }, 4000);
  })
}